<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;" *ngIf="!isMyReport">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Post Assignment Declaration</h5>
  </div>
<div id="mainContent" class="container">
  <div class="modal-body" *ngIf="!isMyReport">
    <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Financial Year<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedFinancialYear"
            >
              <option value="">Select Year</option>
              <option *ngFor="let finance of financialList" [ngValue]="finance">
                {{ finance.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Profile Status<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedProfile"
              (change)="onProfileChanged()"
            >
              <option value="1">Active</option>
              <option value="0">Closed</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Employee Name<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedEmployee"
            >
              <option value="">Select Employee</option>
              <option
                *ngFor="let employee of employeeList"
                [ngValue]="employee"
              >
                {{ employee.firstName }} {{ employee.middleName }}
                {{ employee.lastName }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-4">
            <button
              type="button"
              class="btn btn-sm btn-block btn-outline-theme"
              (click)="onViewReport()"
            >
              View Report
            </button>
          </div>
          <div class="col-sm-4" *ngIf="showExcelButton">
            <button
           type="button"
           class="btn btn-sm btn-block btn-outline-theme"
           (click)="onExportToExcelReport()"
         >
           Export To Excel
         </button></div>

         <div class="col-sm-4" *ngIf="showExcelButton">
           <button (click)="exportToPDFClick()" class="btn btn-sm btn-block btn-outline-theme">
             <i class="fa fa-file-pdf-o mr-2"></i>Export as PDF
           </button>
         </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container" id="mainContent" *ngIf="annualIndependence != null">
  <div class="row pt-3 col-sm-8 justify-content-center text-center">
    <span class="bg-theme-title"
      >P G BHAGWAT LLP, Chartered Accountants
    </span>
  </div>
  <div class="row col-sm-8 justify-content-center text-center ">
    <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
  </div>
  <div class="row pt-4">
    <div class="row col-sm-10">
      <h4 class="col-sm-10" style="text-align: center">
        Annual Firm Personnel Independence Confirmation
      </h4>
    </div>
  </div>
  <div class="row mt-2">
    <div class="row col-sm-10">
      <div class="col-sm-5">
        <label class="col-sm-10 col-form-label"
          >Name of Article/Employee/Partner:
        </label>
      </div>
      <div class="col-sm-4">
        <label class="col-sm-10 col-form-label"
          >{{ annualIndependence.firstName }}
          {{ annualIndependence.middleName }}
          {{ annualIndependence.lastName }}
        </label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="row col-sm-10">
      <div class="col-sm-5">
        <label class="col-sm-4 col-form-label">Designation:</label>
      </div>
      <div class="col-sm-5">
        <label class="col-sm-10 col-form-label"
          >{{ annualIndependence.role }}
        </label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="row col-sm-10">
      <div class="col-sm-5">
        <label class="col-sm-10 col-form-label">Date Of Joining:</label>
      </div>
      <div class="col-sm-5">
        <label class="col-sm-10 col-form-label"
          >{{ annualIndependence.joiningDate | date: "dd-MMM-yyyy" }}
        </label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="row col-sm-10">
      <div class="col-sm-5">
        <label class="col-sm-10 col-form-label">Branch:</label>
      </div>
      <div class="col-sm-5">
        <label class="col-sm-10 col-form-label">{{
          annualIndependence.branch
        }}</label>
      </div>
    </div>
  </div>
  <br />
  <div class="row">
    <div class="row col-sm-10">
      <div class="col-sm-5">
        <label class="col-sm-10 col-form-label"
          >For assignments in respect of FY:</label
        >
      </div>
      <div class="col-sm-5">
        <label class="col-sm-10 col-form-label">{{
          annualIndependence.fyName
        }}</label>
      </div>
    </div>
  </div>

  <div class="row col-sm-10">
    <label class="col-sm-10 col-form-label">DETAILED DECLARATIONS</label>
  </div>

  <div class="row col-sm-10">
    <label class="col-sm-10">{{ annualIndependence.beginText }}</label>
  </div>
  <div class="table-responsive cnstr-record col-sm-10">
    <table class="table table-bordered heading-hvr">
      <tr>
        <th>Sr. No</th>
        <th style="width: 80%">Declaration</th>
        <th>Agree / Disagree</th>
        <!-- <th >Disagree</th> -->
      </tr>
      <tbody
        *ngFor="
          let questions of annualIndependence.empIndepenDeclarationDetails;
          let i = index
        "
      >
        <tr>
          <td>{{ i + 1 }}</td>
          <td>{{ questions.question }}</td>
          <td>
            <input
              type="checkbox"
              [checked]="validateAggreQuestion(questions.answer)"
              disabled
            />
          </td>
          <!-- <td> <input type="checkbox" [checked]="validateDisAggreQuestion(questions.answer)" disabled> </td> -->
        </tr>
      </tbody>
    </table>
  </div>

  <div class="row col-sm-10">
    <label class="col-sm-10 col-form-label"
      >Explanation in cases where 'disagree' responses are given</label
    >
  </div>

  <div class="row col-sm-10">
    <span class="col-sm-10">{{ annualIndependence.dissagreementAnswer }}</span>
  </div>
  <br />

  <div class="row col-sm-10">
    <label class="col-sm-10">{{ annualIndependence.declaration }}</label>
  </div>

  <div class="row col-sm-10">
    <label class="col-sm-10 col-form-label">REPRESENTATION</label>
  </div>
  <div class="row col-sm-10">
    <label class="col-sm-10">{{ annualIndependence.endText }}</label>
  </div>
  <div class="row col-sm-10">
    <div class="col-sm-2">Sign:</div>
    <div class="col-sm-2"><input type="checkbox" checked disabled /></div>
  </div>
  <div class="row col-sm-10">
    <div class="col-sm-2">Name:</div>
    <div class="col-sm-4">
      {{ annualIndependence.firstName }} {{ annualIndependence.middleName }}
      {{ annualIndependence.lastName }}
    </div>
  </div>
  <div class="row col-sm-10">
    <div class="col-sm-2">Designation:</div>
    <div class="col-sm-4">{{ annualIndependence.role }}</div>
  </div>
  <div class="row col-sm-10">
    <div class="col-sm-2">Date:</div>
    <div class="col-sm-4">
      {{ annualIndependence.signedDate | date: "dd-MMM-yyyy" }}
    </div>
  </div>
</div>
